/* global axios */
import ApiClient from './ApiClient';

class TicketsAPI extends ApiClient {
  constructor() {
    super('tickets', { accountScoped: true });
  }

  getForConversation(conversationId, category = 'back_office') {
    return axios.get(this.url, {
      params: { source_conversation_id: conversationId, category },
    });
  }
}

export default new TicketsAPI();
